import React, { useState, useEffect } from 'react';
import {
    CButton, CRow, CCol, CCard, CCardBody, CTab, CTabContent, CTabList, CTabPanel, CTabs, CHeader, CContainer, CHeaderNav, CNavItem, CNavLink, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow
} from '@coreui/react';
import { FaEdit, FaSearch } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsTrash3 } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import Doctorvector from '../../../assets/images/doctorvector.png';
import Adminprofil from '../../../assets/images/adminprofil.png';
import AddStaffModal from './adduserstaff';
import { ToastContainer, toast } from 'react-toastify';
import EditStaffModal from './edituserstaff';
import api from '../../../service/caller';
import ScheduleModal from './scheduleEdit';
import { useNavigate, useLocation } from 'react-router-dom';

import '@coreui/coreui/dist/css/coreui.min.css';
import '@coreui/coreui/dist/js/coreui.bundle.min.js';

import { usePermissions } from '../../../contexts/PermissionContext';
import { User } from 'lucide-react';

const StaffPlan = () => {

    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [modalValue, setModalValue] = useState(null);
    const [isEditModalVisible, setEditModalVisible] = useState(false);
    const [staffs, setStaffs] = useState([]);
    const [activeRole, setActiveRole] = useState("Allusers");
    const [myHospitalUser, setMyHospitalUser] = useState([]);
    const [roles, setRoles] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedUser, setSelectedUser] = useState(null);
    const { hasPermission, userData, loading } = usePermissions();
    const [isScheduleModalVisible, setScheduleModalVisible] = useState(false);
    const [selectedStaffForSchedule, setSelectedStaffForSchedule] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [itemsPerPage] = useState(10);

    const [UserData, setUserData] = useState([]);
    const [HospitalsList, setHospitalsList] = useState([]);

    useEffect(() => {
        const fetchHospitalsList = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const response = await api.get('api/usersprofile');
                const hospitalIds = response.data.hospital_id.map(hospital => hospital._id).join(',');
                fetchMyHospitalUser(hospitalIds);
                setHospitalsList(response.data.hospital_id);
            } catch (error) {
                toast.error(error.message || "Error fetching hospitals");
                console.error("Error fetching Hospitals List:", error);
            }
        };

        const fetchMyHospitalUser = async (hospitalIds) => {
            try {
                const response = await api.get(`api/usersbydepartment?hospital_id=${hospitalIds}`);
                setMyHospitalUser(response.data);
                setTotalPages(Math.ceil(response.data.length / itemsPerPage));
            } catch (error) {
                toast.error("Error fetching hospital users");
                console.error("Error fetching Hospital Users", error);
            }
        };

        const fetchRoles = async () => {
            try {
                const response = await api.get('api/getallroles');
                setRoles(response.data);
            } catch (error) {
                toast.error("Error fetching roles");
                console.error("Error fetching Roles:", error);
            }
        };

        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch user data");
                console.error("Failed to fetch user data:", error);
            }
        };

        fetchHospitalsList();
        fetchLoggedUserData();
        fetchRoles();
    }, []);

    const refreshHospitalUsers = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const response = await api.get(`api/hospitals/admin/${token}`);
            const hospitalIds = response.data.map(hospital => hospital._id).join(',');
            console.log("LOg", hospitalIds);
            const usersResponse = await api.get(`api/usersbydepartment?hospital_id=${hospitalIds}`);
            setMyHospitalUser(usersResponse.data);
        } catch (error) {
            toast.error("Error refreshing hospital users");
            console.error("Refresh error:", error);
        }
    };

    const handleButtonClick = (value) => {
        if (value !== 'Allusers') {
            setModalValue(value);
        } else {
            setModalValue("Allusers");
        }
        setVisible(true);
    };

    const handleStaffAdded = (newStaff) => {
        setStaffs((prev) => [...prev, newStaff]);
        // refreshHospitalUsers();
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleEditClick = (user) => {
        setSelectedUser(user);
        setEditModalVisible(true);
    };

    const handleDetailsClick = (id) => {
        navigate({
            pathname: '/hospitaladmin/staff_details',
            search: `?_id=${id}`
        });
    };

    const handleScheduleClick = (id) => {
        const user = myHospitalUser.find(user => user._id === id);
        setSelectedStaffForSchedule(user);
        setScheduleModalVisible(true);
    };

    const handleScheduleUpdated = () => {
        toast.success("Schedule updated successfully!");
        setScheduleModalVisible(false);
        refreshHospitalUsers();
    };

    const handleDeleteUserClick = async (id) => {
        try {
            const response = await api.delete('api/users/' + id);
            if (response.status === 200 || response.status === 201) {
                toast.success("Staff deleted successfully!");
                refreshHospitalUsers();
            } else {
                toast.error(response.data.message || "Failed to delete staff. Please try again.");
            }
        } catch (error) {
            toast.error(`Deletion failed: ${error?.response?.data?.message || 'An unexpected error occurred. Please try again.'}`);
            console.error('Error:', error?.response || 'No error message available.');
        }
    };

    const handleStaffUpdated = () => {
        refreshHospitalUsers();
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Filter users by role - similar to the first file implementation
    const filterUsersByRole = (role) => {
        if (role === "Allusers") {
            return filterBySearchTerm(myHospitalUser);
        }
        const filteredByRole = myHospitalUser.filter((user) => user.role?._id === role);
        return filterBySearchTerm(filteredByRole);
    };

    // Additional filter for search term
    const filterBySearchTerm = (users) => {
        if (!searchTerm.trim()) return users;

        const term = searchTerm.toLowerCase();
        return users.filter(user =>
            (user.firstname && user.firstname.toLowerCase().includes(term)) ||
            (user.lastname && user.lastname.toLowerCase().includes(term)) ||
            (user.email && user.email.toLowerCase().includes(term)) ||
            (user.phone && user.phone.includes(term)) ||
            (user._id && user._id.includes(term))
        );
    };

    // Get current page data for pagination
    const getCurrentPageItems = (users) => {
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        return users.slice(indexOfFirstItem, indexOfLastItem);
    };

    const renderActionDropdown = (user) => (
        <CButton
            onClick={() => handleScheduleClick(user?._id)}
            className="btn-primary"
            style={{
                backgroundColor: '#0056B3',
                color: 'white',
                width: '100%',
                padding: '10px 20px',
                borderRadius: '20px'
            }}
            active
            tabIndex={-1}
        >
            {!(UserData?.role?.name === "medtinz_client_master" || user?._id === UserData?._id) ? "View Schedule" : "Edit Schedule"}
        </CButton>
    );

    const commonTableColumns = [
        {
            key: 'profile', label: 'Profile', render: user => (
                <img src={Doctorvector} className="cardicon" alt="Consultation Icon" width="50" height="50" />
            )
        },
        { key: 'name', label: 'Name', render: user => `${user?.firstname} ${user?.lastname}` },
        { key: 'role', label: 'Fonction', render: user => user?.role?.name?.replace(/^medtinz_client_/, '').replace(/_/g, ' ') ?? 'Undefined' },
        { key: 'department', label: 'Department', render: user => user.departementId[0]?.name ?? 'No Department' },
        {
            key: 'status', label: 'Status',
            render: user => {
                // FIX: Vérifier si status existe avant d'utiliser charAt
                const status = user.status ?? 'unknown';
                const statusClass = status === 'active' ? 'coloredsucess' : 'coloredechec';
                const capitalized = status.charAt(0).toUpperCase() + status.slice(1);
                return <span className={statusClass}>{capitalized}</span>;
            }
        },
        { key: 'actions', label: 'Action', render: user => renderActionDropdown(user) }
    ];

    const renderTable = (users, roleId) => {
        // Apply search filtering
        const filteredUsers = filterBySearchTerm(users || []);
        // Get current page items
        const currentItems = getCurrentPageItems(filteredUsers);

        return (
            <>
                {/* <div className="d-flex mt-4">
                    {hasPermission('medtinz_client_staff_create') && (
                        <CButton
                            onClick={() => handleButtonClick(roleId)}
                            className="registernewbtn ms-auto d-flex align-items-center"
                            active
                            tabIndex={-1}
                        >
                            <BsPersonPlus className="mx-2" /> Register New User
                        </CButton>
                    )}
                </div> */}

                <div className="search-container w-80">
                    <div className="search-bar">
                        <FaSearch
                            className="search-icon"
                            style={{ width: '20px', height: '20px' }}
                        />
                        <input
                            type="text"
                            placeholder="Search for a patient (Enter ID, name or Tel)"
                            className='ms-4 w-100'
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div>
                </div>

                <CTable hover className='mt-5' align="middle" responsive>
                    <CTableHead>
                        <CTableRow>
                            {commonTableColumns.map(col => (
                                <CTableHeaderCell key={col.key}>{col.label}</CTableHeaderCell>
                            ))}
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {currentItems.length > 0 ? (
                            currentItems.map((user, index) => (
                                <CTableRow key={index}>
                                    {commonTableColumns.map(col => (
                                        <CTableDataCell key={col.key}>
                                            {col.render(user)}
                                        </CTableDataCell>
                                    ))}
                                </CTableRow>
                            ))
                        ) : (
                            <CTableRow>
                                <CTableDataCell colSpan={commonTableColumns.length} className="text-center">
                                    No users found matching your search criteria
                                </CTableDataCell>
                            </CTableRow>
                        )}
                    </CTableBody>
                </CTable>

                <AddStaffModal visible={visible} onClose={() => setVisible(false)} handleStaffAdded={handleStaffAdded} setVisible={setVisible} modalValue={modalValue} handleButtonClick={handleButtonClick} />
            </>
        );
    };

    return (
        <div className="dashboard-header">
            <ToastContainer />
            <EditStaffModal visible={isEditModalVisible} onClose={() => setEditModalVisible(false)} onStaffUpdated={handleStaffUpdated} user={selectedUser} />
            <ScheduleModal
                visible={isScheduleModalVisible}
                onClose={() => setScheduleModalVisible(false)}
                onScheduleUpdated={handleScheduleUpdated}
                staff={selectedStaffForSchedule}
            />

            {/* <div className='row px-4'>
                <div className='col-lg-4 mb-3'>
                    <div className="pagetittle">
                        <h4 className=' text-start'><b>Staff Schedule</b></h4>
                    </div>
                </div>
                <div className='col-lg-4'></div>
                <div className='col-lg-4 mx-auto'>
                    <div className="d-flex justify-content-end gap-4">
                        <div>
                            <img src={Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                        </div>
                        <div>
                            <span className="ms-2">{UserData.firstname} {UserData.lastname}</span>
                            <p className="ms-2">{UserData.role?.name?.replace(/^medtinz_client_/, '').replace(/_/g, ' ')}</p>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
                <div className="hosp-header__content">
                    {/* Titre à gauche */}
                    <div className="hosp-header__title">
                        <h4 className="hosp-page__title"><b>Staff Schedule</b></h4>
                    </div>

                    {/* Profil utilisateur à droite */}
                    <div className="hosp-user__profile">
                        {/* Indicateur de statut en ligne (optionnel) */}
                        <div className="hosp-status__indicator"></div>

                        <img src={UserData?.picture || Adminprofil} className='hosp-profile__image'  alt="Consultation Icon"  />

                        <div className="hosp-user__details">
                            <span className="ms-2">{UserData.firstname} {UserData.lastname}</span>
                            <p className="ms-2">{UserData.role?.name?.replace(/^medtinz_client_/, '').replace(/_/g, ' ')}</p>
                        </div>
                    </div>
                </div>
            </div>


            <div className="Patientlist mt-4">
                <div className='tabsection'>
                    <CRow>
                        <CCol xs={12}>
                            <CCard className="card mb-4 p-4">
                                <CCardBody>
                                    <CTabs activeItemKey={activeRole} onTabChange={setActiveRole}>
                                        <CTabList variant="underline" className="border-bottom">
                                            <CTab itemKey="Allusers">All Users</CTab>
                                            {roles
                                                .filter(role => !['medtinz_client_patient', 'medtinz_client_hospital_settings'].includes(role.name))
                                                .map((role) => (
                                                    <CTab
                                                        itemKey={role._id}
                                                        key={role._id}
                                                        disabled={['medtinz_client_laboratory', 'medtinz_client_pharmacist'].includes(role.name)}
                                                    >
                                                        {role.name.replace(/^medtinz_client_/, '').replace(/_/g, ' ')}
                                                    </CTab>
                                                ))
                                            }
                                        </CTabList>
                                        <CTabContent>
                                            <CTabPanel className="p-3" itemKey="Allusers">
                                                {renderTable(myHospitalUser)}
                                            </CTabPanel>
                                            {roles.map((role) => (
                                                <CTabPanel key={role._id} className="p-3" itemKey={role._id}>
                                                    {renderTable(filterUsersByRole(role._id), role._id)}
                                                </CTabPanel>
                                            ))}
                                        </CTabContent>
                                    </CTabs>

                                    {/* Pagination based on filtered data */}
                                    <div className='paginate me-5'>
                                        <p className='mt-3'>
                                            {myHospitalUser.length > 0 ?
                                                `Showing ${(currentPage - 1) * itemsPerPage + 1} - ${Math.min(currentPage * itemsPerPage, activeRole === "Allusers" ? myHospitalUser.length : filterUsersByRole(activeRole).length)} of ${activeRole === "Allusers" ? myHospitalUser.length : filterUsersByRole(activeRole).length}` :
                                                'No results to show'}
                                        </p>
                                        <div className='actionbtn'>
                                            <div className='left'>
                                                <BsChevronLeft
                                                    className='pagicon'
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </div>
                                            <div className='right'>
                                                <BsChevronRight
                                                    className='pagicon'
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </CRow>
                </div>
            </div>
        </div>
    );
};

export default StaffPlan;